<template>
  <div class="carousel-item" :class="{ active: isActive }" v-bind="$attrs">
    <!-- *** restore the caption container *** -->
    <div class="carousel-caption">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCarouselSlide",
  inject: ["registerSlide", "unregisterSlide", "getActiveIndex"],
  data() {
    return { index: 0 };
  },
  computed: {
    isActive() {
      return this.index === this.getActiveIndex();
    },
  },
  mounted() {
    this.registerSlide(this);
  },
  beforeDestroy() {
    this.unregisterSlide(this);
  },
};
</script>
